import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LineFloatingButton from '../../components/feature/LineFloatingButton';
import ContactHeroSection from './components/ContactHeroSection';
import ContactMethodsSection from './components/ContactMethodsSection';
import ContactFormSection from './components/ContactFormSection';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const contactJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  url: `${SITE_URL}/contact`,
  name: '東京シニア婚活 お問い合わせ・無料相談 | 縁結び 和はは',
  description: '東京のシニア婚活相談所「縁結び和はは」へのお問い合わせ・無料相談のご予約。婚活東京シニア専門で50代・60代・70代の婚活をサポート。',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: '無料相談・お問い合わせ',
    availableLanguage: 'Japanese',
    areaServed: '東京都・関東',
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'お問い合わせ', item: `${SITE_URL}/contact` },
    ],
  },
};

export default function ContactPage() {
  return (
    <>
      <SeoHead
        title="東京シニア婚活 無料相談・お問い合わせ | 縁結び 和はは"
        description="東京のシニア婚活相談所「縁結び和はは」へのお問い合わせ・無料相談のご予約はこちら。婚活東京シニア専門で50代・60代・70代の婚活を電話・LINE・フォームでお気軽にご相談ください。"
        keywords="東京 シニア 婚活, 婚活無料相談 東京, シニア婚活相談所お問い合わせ, 50代婚活相談, 60代婚活東京, 婚活カウンセリング東京"
        path="/contact"
        jsonLd={contactJsonLd}
      />
      <Navbar />
      <main>
        <ContactHeroSection />
        <ContactMethodsSection />
        <ContactFormSection />
      </main>
      <Footer />
      <LineFloatingButton />
    </>
  );
}
